module.exports = __webpack_public_path__ + "img/select.d817ff81.svg";